import { render, staticRenderFns } from "./COA.vue?vue&type=template&id=13104c3e"
import script from "./COA.vue?vue&type=script&lang=js"
export * from "./COA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13104c3e')) {
      api.createRecord('13104c3e', component.options)
    } else {
      api.reload('13104c3e', component.options)
    }
    module.hot.accept("./COA.vue?vue&type=template&id=13104c3e", function () {
      api.rerender('13104c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/COA.vue"
export default component.exports